import React, { useEffect } from 'react';

import { declinedSupportPhone } from '../../../constants/SiteVariables';
import { updateParent } from '../../../lib/modal';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import useSession from '../../../hooks/useSession';
import ReturnToMerchant from '../../shared/ReturnToMerchant';

export default function DeclinedOnReapply({ location }) {
  const [session, sessionActions] = useSession();
  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');

  useRouteStatus(location);

  const redirect = () => {
    if (session.mode === 'modal') {
      updateParent('complete', cart ? cart.cancel_url : '');
    } else {
      if (
        cart &&
        cart.cancel_url &&
        session.session_type === 'standalone' &&
        session.strategy !== 'async'
      ) {
        window.location.href = cart.cancel_url;
      } else if (merchant !== 'undefined') {
        window.location.href = merchant.url;
      } else {
        window.location.href = '/';
      }
    }
  };

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div id="content" className="has-text-centered">
      <h1 className="is-size-4 has-text-weight-semibold">
        We're sorry, Credit Key is unable to extend you additional credit at
        this time.
      </h1>
      <p className="has-text-weight-semibold text-green-highlight">
        You'll receive an email momentarily with further details, including how
        to address any concerns.
      </p>

      <p className="mb-5">
        Any existing loans on your business line of credit will remain open
        until final repayments are complete. You will be eligible to reapply for
        additional credit in six months time.
      </p>

      <p>
        Any additional questions, please contact Credit Key support at{' '}
        <a href="mailto: support@creditkey.com">support@creditkey.com</a> or{' '}
        {declinedSupportPhone}
        
        <ReturnToMerchant
          merchant={merchant}
          redirect={redirect}
        />
      </p>
    </div>
  );
}
